import noticeQueries from '@apis/queries/noticeQueries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function useNotice(noticeId: string) {
    const { pop } = useFlow();
    const { data, status } = useQuery(noticeQueries.detail(noticeId));
    const toast = useToast();
    const { t } = useTranslation('notice');
    useEffect(() => {
        if (status === 'error') {
            toast.error(t('toast.error'));
            pop();
        }
    }, [status]);
    return data;
}

export default useNotice;
